export function checkPermission(requiredPermissions) {
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    if (permissions.indexOf(requiredPermissions) > -1) {
        return true;
    } else {
        return false;
    }
}